import React, { FC, useState, useEffect } from "react";
import { Button } from "@skyportal/ui-kit";
import cn from "classnames";
import SwitchField from "components/SwitchField";
import { useTranslation } from "react-i18next";
import { Bucket } from "containers/BucketsPageContent/mappers/bucketsMapper";

import BucketModalShell from "../BucketModalShell";
import shellStyles from "../BucketModalShell/BucketModalShell.module.css";
import { BaseBucketModalProps } from "../types";

import styles from "./EditBucketModal.module.css";

interface Props extends BaseBucketModalProps {
  bucket: Bucket | null;
}

const EditBucketModal: FC<Props> = ({ open, bucket, onClose }) => {
  const { t } = useTranslation("storageOverview");

  const [versioning, setVersioning] = useState(false);

  useEffect(() => {
    if (!open || !bucket) return;

    setVersioning(bucket.properties?.includes("Versioning") ?? false);
  }, [open, bucket]);

  const handleSave = () => {
    console.log("EDIT BUCKET", {
      id: bucket?.id,
      versioning,
    });

    onClose();
  };

  return (
    <BucketModalShell
      open={open}
      onClose={onClose}
      title={t("modals.edit.title")}
      controls={
        <div className={cn(shellStyles.controls, styles.controls)}>
          <Button type="secondary" onClick={onClose}>
            {t("common:Cancel")}
          </Button>
          <Button type="primary" onClick={handleSave}>
            {t("common:Save")}
          </Button>
        </div>
      }
    >
      <div className={cn(shellStyles.form, styles.form)}>
        <div className={cn(shellStyles.field, styles.field)}>
          <SwitchField label={t("modals.fields.versioning")} checked={versioning} onChange={setVersioning} />
        </div>
      </div>
    </BucketModalShell>
  );
};

export default EditBucketModal;
